<div class="slider-container">
	<div class="row" (click)="sliderOptions.expanded = !sliderOptions.expanded">
		<p class="slider-title">{{ sliderOptions.title | titlecase }}</p>
		<span class="spacer"></span>
		<mat-icon
			[svgIcon]="sliderOptions.expanded ? 'chev-up' : 'chev-down'"
			class="icon-size-12"
		></mat-icon>
	</div>
	<div class="slider-box" [class.expanded]="sliderOptions.expanded">
		<ng-container
			*ngIf="sliderOptions.minValue && sliderOptions.maxValue && !sliderOptions.value">
			<ngx-slider
				[(value)]="sliderOptions.minValue"
				[(highValue)]="sliderOptions.maxValue"
				[options]="sliderOptions.options"
				(valueChange)="onValueChange.emit($event)"
			></ngx-slider>
		</ng-container>

		<ng-container *ngIf="sliderOptions.value || sliderOptions.value === 0">
			<ngx-slider
				[(value)]="sliderOptions.value"
				[options]="sliderOptions.options"
				(valueChange)="onValueChange.emit($event)"
			></ngx-slider>
		</ng-container>
	</div>
</div>
